import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: {
    unit: 'Unit 12',
    id: 'WB3-U12-P84-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page84/2.jpg' },
      ]
    ]
  },
  2: {
    unit: 'Unit 12',
    id: 'WB3-U12-P84-E2',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    textAlign: 'center',
    maxLength: 1,
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page84/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [

      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E2/2.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page84/E2/1.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page84/E2/3.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page84/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page84/E2/5.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page84/E2/6.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page84/E2/7.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page84/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page84/E2/9.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page84/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page84/E2/11.jpg' },
      ],

    ]
  },
  3: { // Exercise num
    unit: 'Unit 12',
    id: 'WB3-U12-P84-E3',
    audio: '',
    video: '',
    component: T6,
    checkUppercase: true,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page84/E3/Key/answerKey.png',
    inputSize: 215,
    // titleQuestion: [{ num: '3', title: 'Listen and write. Then listen again and repeat. <headphone name="25" src="img/FriendsPlus/Page83/Audio/tieude-e2-p83.mp3"></headphone>', color: "#5B5A5D" }],
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page84/E3/1.jpg' /> </div>
          <div style=" position: absolute; top: 153px; left: 534px; "><input id='0' /></div>
          <div style=" position: absolute; top: 203px; left: 309px; "><input id='1' /></div>
          <div style=" position: absolute; top: 253px; left: 280px; "><input id='2' /></div>
          <div style=" position: absolute; top: 303px; left: 281px; "><input id='3' /></div>
          <div style=" position: absolute; top: 353px; left: 455px; "><input id='4' /></div>
          

        </div>
        `,
        answer: [
          "On the farm",
          "horse",
          "sheep",
          "hen",
          "happy",
        ],
      },
    ],
  },





}
export default json;